import { render, staticRenderFns } from "./SalesNoteConfiguration.vue?vue&type=template&id=a6f51d18&"
import script from "./SalesNoteConfiguration.vue?vue&type=script&lang=js&"
export * from "./SalesNoteConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports